import { useEffect, useRef, useState } from "react";

/**
 * Tracks an element's content width so the card can be rendered at an exact
 * pixel size. The card scales everything from that number, so it has to be
 * measured rather than guessed from a media query.
 */
export default function useElementWidth(fallback = 480) {
  const ref = useRef(null);
  const [width, setWidth] = useState(fallback);

  useEffect(() => {
    const node = ref.current;
    if (!node || typeof ResizeObserver === "undefined") return undefined;

    const observer = new ResizeObserver((entries) => {
      const next = entries[0]?.contentRect?.width;
      if (next) setWidth(next);
    });
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return [ref, width];
}
